/*eslint-disable*/
import React from "react";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();
  const isNavyAuthPage =
    pathname === "/SignIn" ||
    pathname === "/SignUp" ||
    pathname === "/PasswordRecovery" ||
    pathname.includes("/auth/verify-email") ||
    pathname.includes("/auth/reset-password");

  return (
    <div className="z-[5] mr-auto flex w-full items-center justify-center px-5 pb-6 lg:max-w-[48%]">
      <p
        className={`text-center text-sm md:text-base ${
          isNavyAuthPage ? "text-gray-400" : "text-gray-600 dark:text-gray-400"
        }`}
      >
        AlphaSniper 2026 © All Rights Reserved
      </p>
    </div>
  );
}
